import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withNavigationErrorHandler } from '@angular/router';
import { routes } from './app.routes';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { authInterceptor } from '@app/core/interceptors/auth.interceptor';
import { EventManager } from '@app/core/observer';

import {
  NgxCurrencyInputMode,
  provideEnvironmentNgxCurrency,
} from '@dintecom/ngx-currency';

import { provideNgxMask } from 'ngx-mask';

import { handleNavigationError } from '@shared/utils';
import {
  APP_INITIALIZER_MAT_DIALOG_DEFAULT_OPTIONS_PROVIDER,
  APP_INITIALIZER_MAT_FORM_FIELD_DEFAULT_OPTIONS_PROVIDER,
} from './core/providers';
import { TENANCY_PROVIDER } from './core/tenancy';

export const appConfig: ApplicationConfig = {
  providers: [
    provideNgxMask(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideEnvironmentNgxCurrency({
      align: 'left',
      allowNegative: false,
      allowZero: true,
      decimal: '.',
      precision: 2,
      prefix: '$ ',
      suffix: '',
      thousands: ',',
      nullable: true,
      min: null,
      max: null,
      inputMode: NgxCurrencyInputMode.Natural,
    }),
    provideRouter(
      routes,
      withNavigationErrorHandler((error) => handleNavigationError(error)),
    ),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    EventManager,
    TENANCY_PROVIDER,
    APP_INITIALIZER_MAT_DIALOG_DEFAULT_OPTIONS_PROVIDER,
    APP_INITIALIZER_MAT_FORM_FIELD_DEFAULT_OPTIONS_PROVIDER,
  ],
};
